import {
   EXECUTIVE_REQUISITION,
  } from "./actionType";
  
  // common success
  export const StoreExecutiveRequisition = (requsition) => ({
    type: EXECUTIVE_REQUISITION,
    payload:requsition,
  });
 